import { deleteRequest, getRequest, putRequest } from '../requests';

export function persistRestorationData(taskId: string, taskResult: unknown) {
    return putRequest(`api/researchkit/tasks/${taskId}/restorationData`, taskResult);
}

export function deleteRestorationData(taskId: string) {
    return deleteRequest(`api/researchkit/tasks/${taskId}/restorationData`);
}

export function getConsentRestorationData(projectID?: string, linkKey?: string) {
    if (linkKey) {
        return getRequest(`api/researchkit/studyparticipant/consentRestorationDataByLinkKey/${linkKey}`);
    }
    if (!projectID) {
        throw new Error('getConsentRestorationData requires either a linkKey or a projectID.');
    }
    return getRequest(`api/researchkit/studyparticipant/consentRestorationData/${projectID}`);
}

export function persistConsentRestorationData(projectID: string, data: unknown) {
    return putRequest(`api/researchkit/studyparticipant/consentRestorationData/${projectID}`, data);
}

export function deleteConsentRestorationData(projectID: string) {
    return deleteRequest(`api/researchkit/studyparticipant/consentRestorationData/${projectID}`);
}
